import { topicsData } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 text-xs font-medium text-accent-400 mb-3">
            <i className="ri-hashtag"></i>
            大家在看
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门话题</h2>
          <p className="mt-2 text-sm text-foreground-500">全网影迷热议话题一网打尽</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((item) => (
            <div
              key={item.id}
              className="group flex items-center gap-3 px-4 py-3 rounded-full bg-background-50 border border-background-200/60 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <span className="text-xs font-semibold text-foreground-400">#{item.id}</span>
              <span className="text-sm font-medium text-foreground-800">{item.name}</span>
              {item.tag && (
                <span className={`px-1.5 py-0.5 rounded text-[10px] font-bold ${
                  item.tag === '爆' ? 'bg-accent-500 text-background-50' : 'bg-primary-500/15 text-primary-400'
                }`}>
                  {item.tag}
                </span>
              )}
              <span className="text-xs text-foreground-500">{item.heat}热度</span>
              <i className="ri-arrow-right-up-line text-xs text-foreground-400 opacity-0 group-hover:opacity-100 transition-opacity"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}